export const isOverwolfApp = typeof overwolf !== 'undefined';
